import { Box, Text } from "@chakra-ui/react";

import { RanaHeading, RanaLoading } from "@nens/ranalib";

import { useTenantQuery } from "@/queries/query-tenant";

export function TenantCompanyDetails() {
  const tenantResponse = useTenantQuery();

  if (tenantResponse.isLoading) return <RanaLoading />;
  if (!tenantResponse.isSuccess) return null;

  const tenant = tenantResponse.data;

  return (
    <Box>
      <RanaHeading type="h5" mb={6}>
        {tenant.name}
      </RanaHeading>
      <Text>{tenant.description}</Text>
    </Box>
  );
}
